import { useEffect, useState } from 'react';
import { CancelTokenSource } from 'axios';

import {
  analyzeErrorType,
  EErrorTypes,
  httpClientCancelTokenStatic,
  instanceOfIError,
} from '@trader/services';
import { api } from '@trader/api';

let cancelTokenSource: CancelTokenSource | null = null;

const defaultState = {
  requiredMargin: 0,
  currencyConvert: 0,
  inProgress: false,
  isInsufficientFundsError: false,
  isRequestError: false,
};

export const useRequiredOpenCost = () => {
  const [requiredOpenCost, setRequiredOpenCost] = useState(defaultState);

  useEffect(() => {
    return () => {
      setRequiredOpenCost(defaultState);
    };
  }, []);

  const getRequiredOpenCost = async (
    symbol,
    side,
    quantity,
    price,
    onSuccess?: () => void,
    onError?: (errorType: EErrorTypes) => void,
    ignoreCancelToken?: boolean
  ) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel('CANCEL_REQUEST');
    }
    cancelTokenSource = httpClientCancelTokenStatic.source();

    setRequiredOpenCost({
      ...requiredOpenCost,
      isInsufficientFundsError: false,
      isRequestError: false,
      inProgress: true,
    });

    try {
      const response = await api.Trading.getRequiredOpenCost(
        {
          symbol,
          side,
          quantity,
          price,
        },
        {
          cancelToken: {
            cancelToken:
              ignoreCancelToken === true ? undefined : cancelTokenSource.token,
          },
        }
      );

      onSuccess && onSuccess();
      setRequiredOpenCost({
        requiredMargin: response.requiredOpenCosts,
        currencyConvert: response.costDetails.instrumentConversionRate,
        isInsufficientFundsError: false,
        isRequestError: false,
        inProgress: false,
      });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (errorData: any) {
      const errors = errorData?.response?.data?.errors;
      let isInsufficientError = false;

      // Check on insufficient funds error
      if (Array.isArray(errors)) {
        for (const error of errors) {
          if (instanceOfIError(error)) {
            const errorType = analyzeErrorType(error);
            if (errorType === EErrorTypes.INSUFFICIENT_FUNDS) {
              isInsufficientError = true;
            }
            break;
          }
        }
      }

      onError &&
        onError(
          isInsufficientError
            ? EErrorTypes.INSUFFICIENT_FUNDS
            : EErrorTypes.UNKNOWN
        );
      setRequiredOpenCost({
        ...requiredOpenCost,
        isInsufficientFundsError: isInsufficientError,
        isRequestError: errorData?.message !== EErrorTypes.CANCEL_REQUEST,
        inProgress: false,
      });
    }
  };

  return {
    requiredOpenCost,
    getRequiredOpenCost,
  };
};
